import apiService from "./apiService";

const ITEM_PER_PAGE = 10;
export const getCampaignBrands = () => {
  return apiService.get(URIS.campaign_brands);
};

export const getBrandDayInfo = (id) => {
  const params = {
    id
  };
  return apiService.get(URIS.campaign_brands, {params});
};

export const getBrandWeekList = () => {
  return apiService.get(URIS.product_brands_banners);
};

export const getBrandList = (page=1, featured = false, itemPerPage=ITEM_PER_PAGE) => {
  const params = {
    page: page,
    item_per_page: itemPerPage,
    ...(featured && {featured: featured}),
  }
  return apiService.get(URIS.brands, {params});
};

export const getBrandMonthList = (page=1, id, itemPerPage=ITEM_PER_PAGE) => {
  const params = {
    page: page,
    item_per_page: itemPerPage
  }
  return apiService.get(URIS_D('campaign_brand', id), {params});
};

export const getBrand = (brandId) => {
  return apiService.get(URIS_D('product_brand', brandId));
};

const URIS_D = (url,param1) =>  {
  return {
    campaign_brand:`${URIS.campaign_brands}/${param1}`,
    product_brand:`${URIS.product_brands}/${param1}`,
  }[url]
}

const URIS = {
  campaign_brands: '/v1/campaign-brands',
  product_brands_banners: '/v1/product-brands/banners',
  product_brands: '/v1/product-brands',
  brands: '/v1/products/brands',
};
